module.exports = __webpack_public_path__ + "img/banano-bet-logo-yv.8ea1281d1d05d8d6e221e2ef09f6e7a7.svg";